<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>

      <div class="detail-content-body-div flex-1">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="订单信息" name="order">
            <div class="order-header">
              <div class="section-title">
                订单编号:
                <span class="order-no">{{ form.activityOrderNo || "暂无" }}</span>
              </div>
            </div>
            <el-divider />
            <div class="section-title" style="display:flex;align-items:center;">
              <span style="flex:1;">订单基本信息</span>
              <!-- 售后换桩/取消换桩: 仅使用中/暂停使用 或 换桩中显示 -->
              <el-button v-if="form.orderStatus === 'IN_USE' || form.orderStatus === 'PAUSE'"
                type="primary" size="small" @click="onPileSwapInitiate">售后换桩</el-button>
              <el-button v-if="form.orderStatus === 'SWAPPING' && !form.swapUnbound"
                type="warning" size="small" @click="onPileSwapCancel">取消换桩</el-button>
              <el-tooltip v-if="form.orderStatus === 'SWAPPING' && form.swapUnbound"
                content="用户已解绑,无法取消" placement="top">
                <el-button type="warning" size="small" disabled>取消换桩</el-button>
              </el-tooltip>
            </div>
            <el-form :model="form" label-width="200px" class="form-block" size="small">
              <el-row :gutter="20">
                <el-col v-for="item in formFields" :key="item.prop" :span="item.span || 12">
                  <el-form-item :label="item.label">
                    <el-input v-if="!item.type && item.options === undefined" :value="item.prop === 'orderStatus'
                      ? getOrderStatusName(form[item.prop])
                      : item.prop === 'signStatus'
                        ? getSignStatusName(form[item.prop])
                        : item.prop === 'holdAgreement'
                          ? getHoldAgreementName(form[item.prop])
                          : item.prop === 'actualAmountStatus'
                            ? getFlowStatusName(form[item.prop])
                            : form[item.prop]" @input="val => item.prop !== 'orderStatus' && (form[item.prop] = val)"
                      :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || ''" />
                    <el-select v-else-if="item.options" v-model="form[item.prop]" :disabled="!isEditable(item.prop)"
                      :placeholder="item.placeholder || '请选择'" class="full-width">
                      <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                        :value="option.value" />
                    </el-select>
                    <el-date-picker v-else-if="item.type === 'datetime'" v-model="form[item.prop]" type="datetime"
                      :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || '请选择日期时间'"
                      value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" size="small">
                    </el-date-picker>
                    <el-input v-else-if="item.type === 'textarea'" type="textarea" :rows="item.rows || 3"
                      v-model="form[item.prop]" :disabled="!isEditable(item.prop)" :placeholder="item.placeholder || ''"
                      :maxlength="item.prop === 'remark' ? 500 : undefined" :show-word-limit="item.prop === 'remark'" />
                    <ZD-area-select v-else-if="item.type === 'area-select'" ref="areaSelect" :key="areaSelectKey"
                      :showLevel="'3'" :selProvince="form.province" :selCity="form.city" :selArea="form.area"
                      :disabledFlag="!isEditable('province')" @updateSelAreas="updateAreaSelection" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="平台服务费信息" name="flow">
            <FlowServiceTable :activity-order-id="form.activityOrderId"
              :activity-order-no="form.activityOrderNo"
              :user-name="form.name"
              :user-mobile="form.mobile"
              :activity-name="form.purchaseName"
              :activity-type="activityType"
              @gift-success="onGiftSuccess" />
          </el-tab-pane>

          <el-tab-pane label="解约申请记录" name="terminate">
            <TerminateRecordTable :activityorderNo="form.activityOrderNo" />
          </el-tab-pane>

          <el-tab-pane label="换桩记录" name="pileSwap">
            <PileSwapRecordTable v-if="activeTab === 'pileSwap'" :activityorderNo="form.activityOrderNo" @refresh="reloadDetail" />
          </el-tab-pane>

          <!-- 698 小红书分享活动（ADM-2）：单订单笔记列表，序号从 1 起、历史未通过记录占号 -->
          <el-tab-pane label="小红书活动" name="xhsActivity">
            <!-- 点「服务费支付流水号」→ 切到本页「平台服务费信息」Tab（tab 名 flow，见 el-tabs 的 v-model） -->
            <XhsActivityTable v-if="activeTab === 'xhsActivity'" :activityorderNo="form.activityOrderNo"
              @go-fee-tab="activeTab = 'flow'" />
          </el-tab-pane>
        </el-tabs>

        <div class="bottom-actions">
          <el-button type="primary" @click="onSave" v-if="activeTab === 'order' && isEditMode">保存</el-button>
          <el-button type="primary" plain @click="goEdit" v-if="activeTab === 'order' && !isEditMode">编辑</el-button>
          <el-button @click="onBack">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlowServiceTable from './flow-service-table.vue'
import TerminateRecordTable from './terminate-record-table.vue'
import PileSwapRecordTable from './pile-swap-record-table.vue'
import XhsActivityTable from '../xhsActivity/xhs-activity-table.vue'
import ZDAreaSelect from '@/components/area-select/index.vue';

export default {
  name: 'AnxinPackActivityDetail',
  components: {
    FlowServiceTable,
    TerminateRecordTable,
    PileSwapRecordTable,
    XhsActivityTable,
    ZDAreaSelect,
  },
  computed: {
    isEditMode() {
      return this.$route.query.mode === 'edit'
    },
  },
  data() {
    return {
      mode: this.$route.query.mode || 'view',
      // 从列表页跳进来时可指定落地页签（平台服务费流水号 → tab=flow）；默认仍是订单信息
      activeTab: this.$route.query.tab || 'order',
      areaSelectKey: 0,
      activityType: this.$route.query.activityType || '',
      pageTitle: '安心包598活动服务列表详情',
      detailBreadCrumb: [
        { type: 'title', name: '首页' },
        { type: 'title', name: '营销活动' },
        { type: 'title', name: '安心包598活动' },
        { type: 'title', name: '安心包598服务列表' },
        { type: 'title', name: '订单详情' },
      ],
      form: {
        activityOrderNo: '',
        activityOrderId: '',
        orderStatus: '',
        name: '',
        mobile: '',
        purchaseName: '',
        // 流量服务
        actualAmountStatus: '',
        actualAmountStartTime: '',
        actualAmountEndTime: '',
        actualAmountDaysRemaining: '',
        actualAmountCumulativeMonths: '',
        actualAmountTotal: '',
        // 代扣
        holdAgreement: '',
        signStatus: '',
        signTime: '',
        // 联系/安装
        activityOrderContractStatusName: '',
        activityOrderInstallStatusName: '',
        installFailReason: '',
        // 桩信息
        pileCode: '',
        pileAssetCode: '',
        pileInstallOrderNo: '',
        pileInstallCompletedTime: '',
        bindTime: '',
        activateOperatePer: '',
        activateOperateWhen: '',
        // 时间节点
        createdWhen: '',
        cancelRequestTime: '',
        cancelFinishTime: '',
        // 解约/买断/退款
        cancelReason: '',
        cancelPayableAmount: '',
        cancelAmount: '',
        refundAmount: '',
        buyoutOrNot: '',
        rebackedAmount: '',
        rebackedAmountOperatePer: '',
        refundOperateTime: '',
        refundFinishTime: '',
        // 地址
        province: '',
        city: '',
        area: '',
        address: '',
        remark: '',
        swapStatus: null,
        swapUnbound: null,
      },
      lastLoadedKey: '',
      formFields: [
        {
          label: '订单状态', prop: 'orderStatus', options: [
            { label: '已报名', value: 'COMMIT' },
            { label: '待签约', value: 'TO_SIGN' },
            { label: '已签约', value: 'IN_SIGN' },
            { label: '待安装', value: 'TO_INSTALL' },
            { label: '待激活', value: 'TO_ACTIVATION' },
            { label: '使用中', value: 'IN_USE' },
            { label: '待守约', value: 'TO_COMPLIANCE' },
            { label: '已逾期', value: 'IN_OVERDUE' },
            { label: '已违约', value: 'IN_DEFAULTED' },
            { label: '待续费', value: 'TO_RENEWED' },
            { label: '解约申请中', value: 'IN_CANCELING' },
            { label: '已解约(买断)', value: 'IN_CANCELLED_BUYOUT' },
            { label: '已解约(退出)', value: 'IN_CANCELLED_REFUNDED' },
            { label: '已解约(违约)', value: 'IN_CANCELLED_DEFAULTED' },
            { label: '已解约(到期)', value: 'IN_EXPIRED' },
            { label: '已退出', value: 'IN_CLOSE' },
            { label: '待激活签约', value: 'TO_RESET_SIGN' },
            { label: '暂停使用', value: 'PAUSE' },
            { label: '已解约(未安装退出)', value: 'CANCELLED_NOT_INSTALL' },
            { label: '提前买断·使用中', value: 'BUYOUT_IN_USE_STATUS' },
            { label: '已解约·违约买断', value: 'HAVING_ERROR_ILLEGAL_BUYOUT' },
            { label: '换桩中', value: 'SWAPPING' },
          ]
        },
        { label: '姓名', prop: 'name' },
        { label: '用户手机号', prop: 'mobile' },
        { label: '购买名称', prop: 'purchaseName' },
        { label: '流量服务状态', prop: 'actualAmountStatus' },
        { label: '流量服务当前开始时间', prop: 'actualAmountStartTime', type: 'datetime' },
        { label: '流量服务当前到期时间', prop: 'actualAmountEndTime', type: 'datetime' },
        { label: '流量服务剩余天数', prop: 'actualAmountDaysRemaining' },
        { label: '流量服务累计使用月数', prop: 'actualAmountCumulativeMonths' },
        { label: '流量服务累计支付（元）', prop: 'actualAmountTotal' },
        { label: '商家代扣状态', prop: 'holdAgreement' },
        { label: '首次代扣权益', prop: 'signStatus' },
        { label: '首次代扣开通时间', prop: 'signTime', type: 'datetime' },
        {
          label: '客服联系状态',
          prop: 'activityOrderContractStatusName',
          options: [
            { label: '待联系', value: '待联系' },
            { label: '已联系', value: '已联系' },
            { label: '未联系上', value: '未联系上' },
          ],
        },
        {
          label: '安装状态',
          prop: 'activityOrderInstallStatusName',
          options: [
            { label: '未勘察未安装', value: '未勘察未安装' },
            { label: '已勘察已安装', value: '已勘察已安装' },
            { label: '已勘察不安装', value: '已勘察不安装' },
            { label: '未勘察不安装', value: '未勘察不安装' },
          ],
        },
        { label: '不安装/不签约原因', prop: 'installFailReason' },
        { label: '产品编号', prop: 'pileCode' },
        { label: '充电桩资产编号', prop: 'pileAssetCode' },
        { label: '报名创建时间', prop: 'createdWhen', type: 'datetime' },
        { label: '关联主服订单编号', prop: 'pileInstallOrderNo', placeholder: '请输入关联主服订单号' },
        { label: '绑定激活时间', prop: 'bindTime', type: 'datetime' },
        { label: '充电桩安装完成时间', prop: 'pileInstallCompletedTime', type: 'datetime' },
        { label: '激活切换操作人', prop: 'activateOperatePer' },
        { label: '激活切换操作时间', prop: 'activateOperateWhen', type: 'datetime' },
        { label: '解约申请时间', prop: 'cancelRequestTime', type: 'datetime' },
        { label: '解约完成时间', prop: 'cancelFinishTime', type: 'datetime' },
        { label: '解约原因', prop: 'cancelReason' },
        { label: '解约应付金额（元）', prop: 'cancelPayableAmount' },
        { label: '解约应退金额（元）', prop: 'cancelAmount' },
        { label: '退款金额（元）', prop: 'refundAmount' },
        { label: '是否买断回退', prop: 'buyoutOrNot' },
        { label: '回退金额（元）', prop: 'rebackedAmount' },
        { label: '解约退款操作人', prop: 'rebackedAmountOperatePer' },
        { label: '解约退款操作时间', prop: 'refundOperateTime', type: 'datetime' },
        { label: '解约退款完成时间', prop: 'refundFinishTime', type: 'datetime' },
        { label: '省市区', prop: 'areaSelect', type: 'area-select', span: 24 },
        { label: '详细地址', prop: 'address', placeholder: '请输入详细地址', span: 24 },
        { label: '备注', prop: 'remark', type: 'textarea', rows: 4, placeholder: '请输入备注信息（500字以内）', span: 24 },
      ],
      editableFields: [
        'activityOrderContractStatusName',
        'pileInstallOrderNo',
        'activityOrderInstallStatusName',
        'pileInstallCompletedTime',
        'province',
        'city',
        'area',
        'address',
        'remark',
      ],
    }
  },
  watch: {
    '$route.query'(val) {
      this.mode = val.mode || 'view'
      if (val.orderNo) {
        this.form.activityOrderNo = val.orderNo
        this.form.activityOrderId = val.activityOrderId || ''
        this.loadDetailData()
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    goEdit() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          mode: 'edit',
        },
      })
    },
    init() {
      const orderNo = this.$route.query.orderNo
      if (orderNo) {
        this.form.activityOrderNo = orderNo
        this.form.activityOrderId = this.$route.query.activityOrderId || ''
        this.loadDetailData()
      }
    },
    loadDetailData() {
      const _ = this
      if (!_.form.activityOrderNo && !_.form.activityOrderId) return Promise.resolve();
      const loadKey = _.form.activityOrderId || _.form.activityOrderNo
      if (!loadKey) return Promise.resolve()
      // 同一订单只加载一次，避免触发 areaSelectKey 重挂导致重复请求
      if (loadKey === _.lastLoadedKey) return Promise.resolve()
      _.lastLoadedKey = loadKey
      _.$U.showLoading(_);
      return _.$H.post(_, _.$A.activityOrder.axbAppGet, {
        // activityExtendTypeEnum: 'AXB_598_ACTIVITY_PAY',
        // activityOrderId: _.form.activityOrderId,
        activityOrderNo: _.form.activityOrderNo,
      }).then((res) => {
        const payload = res?.data?.data ?? res?.data ?? {};
        const status = res?.data?.status ?? 200;
        if (status === 200) {
          const data = payload || {};
          Object.keys(_.form).forEach((key) => {
            if (data[key] !== null && data[key] !== undefined) {
              _.form[key] = data[key];
            }
          });
          // 字段兼容：部分接口字段命名不同，统一到页面展示字段
          const isEmpty = (v) => v === '' || v === null || v === undefined
          // activityType 兜底：路由未携带时从接口响应获取
          if (isEmpty(_.activityType)) {
            _.activityType = data.activityType ?? ''
          }
          if (isEmpty(_.form.pileInstallOrderNo)) {
            _.form.pileInstallOrderNo = data.pileInstallOrderNo ?? data.mainServiceOrderNo ?? ''
          }
          if (isEmpty(_.form.pileInstallCompletedTime)) {
            _.form.pileInstallCompletedTime = data.pileInstallCompletedTime ?? data.pileInstallCompleteTime ?? ''
          }

          // 流量统计字段（接口字段名可能不同）
          if (isEmpty(_.form.actualAmountCumulativeMonths)) {
            _.form.actualAmountCumulativeMonths =
              data.actualAmountCumulativeMonths ?? data.totalUseMonths ?? data.monthsOfUse ?? ''
          }
          if (isEmpty(_.form.actualAmountTotal)) {
            _.form.actualAmountTotal =
              data.actualAmountTotal ?? data.accumulatedPayments ?? data.accumulatedPaymentAmount ?? data.totalPayAmount ?? ''
          }
          if (isEmpty(_.form.actualAmountDaysRemaining)) {
            _.form.actualAmountDaysRemaining = data.actualAmountDaysRemaining ?? data.daysRemaining ?? ''
          }
          if (isEmpty(_.form.actualAmountStartTime)) {
            _.form.actualAmountStartTime = data.actualAmountStartTime ?? data.startTime ?? data.activeStartDatetime ?? ''
          }
          if (isEmpty(_.form.actualAmountEndTime)) {
            _.form.actualAmountEndTime = data.actualAmountEndTime ?? data.endTime ?? data.expiryDatetime ?? ''
          }

          // 解约/退款字段兼容
          if (isEmpty(_.form.refundAmount)) _.form.refundAmount = data.refundAmount ?? data.cancelAmount ?? ''
          if (isEmpty(_.form.cancelAmount)) _.form.cancelAmount = data.cancelAmount ?? ''

          // 兼容：接口状态字段可能返回 code 或 name
          // orderStatus：页面展示使用 getOrderStatusName(code) / 允许 name 直显
          if (isEmpty(_.form.orderStatus)) {
            _.form.orderStatus = data.orderStatusName ?? data.orderStatus ?? ''
          }
          // 联系/安装：select 的 v-model 期望为中文 name
          if (isEmpty(_.form.activityOrderContractStatusName)) {
            _.form.activityOrderContractStatusName =
              data.activityOrderContractStatusName ??
              _.getContractStatusNameFromCode(data.activityOrderContractStatus) ??
              data.activityOrderContractStatus ??
              ''
          }
          if (isEmpty(_.form.activityOrderInstallStatusName)) {
            _.form.activityOrderInstallStatusName =
              data.activityOrderInstallStatusName ??
              _.getInstallStatusNameFromCode(data.activityOrderInstallStatus) ??
              data.activityOrderInstallStatus ??
              ''
          }
          this.$nextTick(() => {
            // 不再使用强制 remount，避免 area/list 重复请求
          });
        } else {
          _.$message.error(res.data?.message || '获取详情失败');
        }
      }).catch(() => {
        _.$message.error('获取详情失败');
      }).finally(() => {
        _.$U.hideLoading(_);
      });
    },
    getOrderStatusName(status) {
      const statusMap = {
        COMMIT: '已报名',
        TO_SIGN: '待签约',
        IN_SIGN: '已签约',
        TO_INSTALL: '待安装',
        TO_ACTIVATION: '待激活',
        IN_USE: '使用中',
        TO_COMPLIANCE: '待守约',
        IN_OVERDUE: '已逾期',
        IN_DEFAULTED: '已违约',
        TO_RENEWED: '待续费',
        IN_CANCELING: '解约申请中',
        IN_CANCELLED_BUYOUT: '已解约(买断)',
        IN_CANCELLED_REFUNDED: '已解约(退出)',
        IN_CANCELLED_DEFAULTED: '已解约(违约)',
        IN_EXPIRED: '已解约(到期)',
        IN_CLOSE: '已退出',
        TO_RESET_SIGN: '待激活签约',
        PAUSE: '暂停使用',
        CANCELLED_NOT_INSTALL: '已解约(未安装退出)',
        BUYOUT_IN_USE_STATUS: '提前买断·使用中',
        HAVING_ERROR_ILLEGAL_BUYOUT: '已解约·违约买断',
        SWAPPING: '换桩中',
      }
      return statusMap[status] || status
    },
    getSignStatusName(status) {
      if (status === 'Y') return '未开通'
      if (status === 'N') return '开通'
      return status
    },
    getHoldAgreementName(status) {
      if (status === 'Y') return '已签约'
      if (status === 'N') return '未签约'
      return status
    },
    getFlowStatusName(status) {
      const statusMap = {
        COMMIT: '已报名',
        TO_SIGN: '待签约',
        IN_SIGN: '已签约',
        TO_INSTALL: '待安装',
        TO_ACTIVATION: '待激活',
        IN_USE: '使用中',
        TO_COMPLIANCE: '待守约',
        IN_OVERDUE: '已逾期',
        IN_DEFAULTED: '已违约',
        IN_CANCELING: '解约申请中',
        IN_CANCELLED_BUYOUT: '已解约(买断)',
        IN_CANCELLED_REFUNDED: '已解约(退出)',
        IN_CANCELLED_DEFAULTED: '已解约(违约)',
        IN_EXPIRED: '已解约(到期)',
        IN_CLOSE: '已退出',
        TO_RESET_SIGN: '待激活签约',
        PAUSE: '暂停使用',
        BUYOUT_IN_USE_STATUS: '提前买断·使用中',
        HAVING_ERROR_ILLEGAL_BUYOUT: '已解约·违约买断',

        // 兼容历史接口字段
        TO_EXPRIRED: '即将到期',
        TO_EXPIRED: '即将到期',
        EXPIRED: '已过期',
        EXPIRING_SOON: '即将到期',
        TO_ACTIVE: '待激活',
        ACTIVE: '正常',
        IN_ACTIVE: '正常',
        CANCELLED: '已解约（买断）',
        TO_RENEWED: '待续费',
      }
      return statusMap[status] || status
    },
    isEditable(prop) {
      return this.isEditMode && this.editableFields.includes(prop)
    },
    updateAreaSelection(areaData) {
      this.form.province = areaData.province || ''
      this.form.city = areaData.city || ''
      this.form.area = areaData.area || ''
    },
    getContractStatusCode(statusName) {
      const statusMap = {
        '待联系': 'WAIT_CONTRACT',
        '已联系': 'CONTRACTED',
        '未联系上': 'NOT_CONTRACT',
      };
      return statusMap[statusName] || statusName;
    },
    getContractStatusNameFromCode(statusCode) {
      const statusMap = {
        WAIT_CONTRACT: '待联系',
        CONTRACTED: '已联系',
        NOT_CONTRACT: '未联系上',
      };
      return statusMap[statusCode] || statusCode || '';
    },
    getInstallStatusCode(statusName) {
      const statusMap = {
        '未勘察未安装': 'INVESTIGATION_INSTALL_INIT',
        '已勘察已安装': 'INVESTIGATION_INSTALL_FINISHED',
        '已勘察不安装': 'INVESTIGATION_FINISHED_NOT_INSTALL',
        '未勘察不安装': 'INVESTIGATION_INIT_NOT_INSTALL',
      };
      return statusMap[statusName] || statusName;
    },
    getInstallStatusNameFromCode(statusCode) {
      const statusMap = {
        INVESTIGATION_INSTALL_INIT: '未勘察未安装',
        INVESTIGATION_INSTALL_FINISHED: '已勘察已安装',
        INVESTIGATION_FINISHED_NOT_INSTALL: '已勘察不安装',
        INVESTIGATION_INIT_NOT_INSTALL: '未勘察不安装',
      };
      return statusMap[statusCode] || statusCode || '';
    },
    onSave() {
      if (!this.isEditMode) return;
      // 校验：填写了安装完成时间，必须先填写关联主服订单编号
      if (this.form.pileInstallCompletedTime && !this.form.pileInstallOrderNo) {
        this.$message.error('填写充电桩安装完成时间时，必须先填写关联主服订单编号');
        return;
      }
      // 校验：选择已勘察已安装，必须填写安装完成时间
      if (
        this.getInstallStatusCode(this.form.activityOrderInstallStatusName) === 'INVESTIGATION_INSTALL_FINISHED' &&
        !this.form.pileInstallCompletedTime
      ) {
        this.$message.error('选择安装状态为已勘察已安装时，必须填写安装完成时间');
        return;
      }
      const updateParams = {
        activityOrderNo: this.form.activityOrderNo,
        activityOrderContractStatus: this.getContractStatusCode(this.form.activityOrderContractStatusName),
        activityOrderContractStatusName: this.form.activityOrderContractStatusName,
        activityOrderInstallStatus: this.getInstallStatusCode(this.form.activityOrderInstallStatusName),
        activityOrderInstallStatusName: this.form.activityOrderInstallStatusName,
        pileInstallOrderNo: this.form.pileInstallOrderNo,
        // 兼容部分活动接口字段名
        mainServiceOrderNo: this.form.pileInstallOrderNo,
        pileInstallCompletedTime: this.form.pileInstallCompletedTime,
        // 兼容部分活动接口字段名
        pileInstallCompleteTime: this.form.pileInstallCompletedTime,
        activityOrder: {
          province: this.form.province,
          city: this.form.city,
          area: this.form.area,
          address: this.form.address,
          remark: this.form.remark || '',
        },
      };

      this.$U.showLoading(this);
      const expectedPileInstallOrderNo = this.form.pileInstallOrderNo || '';
      const expectedPileInstallCompletedTime = this.form.pileInstallCompletedTime || '';
      this.$H.post(this, this.$A.activityOrder.update, updateParams)
        .then((res) => {
          if (res.data && res.data.status === 200) {
            // 保存后强制重查，避免只看到本地内存值，便于识别后端是否真正持久化
            this.lastLoadedKey = ''
            return this.loadDetailData().then(() => {
              const orderNoPersisted =
                (this.form.pileInstallOrderNo || '') === expectedPileInstallOrderNo
              const completedTimePersisted =
                (this.form.pileInstallCompletedTime || '') === expectedPileInstallCompletedTime
              if (orderNoPersisted && completedTimePersisted) {
                this.$message.success('保存成功!');
              } else {
                this.$message.warning('保存接口返回成功，但详情接口未回显最新值，请后端排查该活动保存字段映射');
              }
            })
          } else {
            this.$message.error(res.data?.message || '保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        })
        .finally(() => {
          this.$U.hideLoading(this);
        });
    },
    onBack() {
      this.$router.go(-1)
    },
    onGiftSuccess() {
      this.reloadDetail();
    },
    // 强制重查详情(操作后刷新活动状态)
    reloadDetail() {
      this.lastLoadedKey = '';
      return this.loadDetailData();
    },
    onPileSwapInitiate() {
      const _ = this;
      _.$confirm('确认发起售后换桩?发起后活动状态将变为"换桩中",用户需在小程序解绑旧桩并绑定新桩。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.axbPileSwapInitiate, {
          activityOrderNo: _.form.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已发起换桩');
            _.reloadDetail();
          } else {
            _.$message.error((res && res.data && res.data.message) || '发起换桩失败');
          }
        }).catch(() => _.$message.error('发起换桩失败'));
      }).catch(() => {});
    },
    onPileSwapCancel() {
      const _ = this;
      _.$confirm('确认取消换桩?取消后将恢复活动为换桩前的状态。', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.axbPileSwapCancel, {
          activityOrderNo: _.form.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已取消换桩');
            _.reloadDetail();
          } else {
            _.$message.error((res && res.data && res.data.message) || '取消换桩失败');
          }
        }).catch(() => _.$message.error('取消换桩失败'));
      }).catch(() => {});
    },
  },
}
</script>

<style lang="less" scoped>
.detail-container {
  height: 100%;
}

.detail-content-div {
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
}

.detail-content-body-div {
  overflow-y: auto;
}

.detail-content-header-div {
  margin-bottom: 20px;
}

.left-page-title-div {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.order-header {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.order-no {
  color: #409EFF;
  font-weight: 500;
}


.form-block {
  // background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.form-block::v-deep .el-form-item__label {
  white-space: nowrap;
}

.full-width {
  width: 100%;
}

.bottom-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
</style>
